import IconChevronRight from "../../../../../components/icons/icon-chevron-right/icon-chevron-right";
import IconCircleLeft from "../../../../../components/icons/icon-circle-left/icon-circle-left";
import { ButtonIcon } from "../../../../../components/inputs/button-icon/button-icon";
import "./rma-navigation.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {observer} from "mobx-react";
import appLayoutStore from "../../../../../stores/app-layout-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
    nextRmaId?: number,
    prevRmaId?: number,
    disabled?: boolean;
}

const RmaNavigation: React.FC<IProps> = observer(({ nextRmaId, prevRmaId, disabled }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [navigateToId, setNavigateToId] = useState<number | undefined>(undefined);
    useEffect(() => {
        if (navigateToId) {
            const newPath = `${pathname}/../${navigateToId}`;
            navigate({
                pathname: newPath
            },
                { replace: true }
            );
        }
    }, [navigateToId, navigate, pathname]);

    const defaultTop = 36;
    const onPrevRmaClick = () => {
        rmsMixpanelStore.trackEvent('d&_previous_rma_arrow');
        setNavigateToId(prevRmaId);
    }

    const onNextRmaClick = () => {
        rmsMixpanelStore.trackEvent('d&_next_rma_arrow');
        setNavigateToId(nextRmaId);
    }


    return (
        <div className="rma-navigation-container" style={{top: (defaultTop + appLayoutStore.headerHeight)}}>
            <ButtonIcon
                disabled={!prevRmaId || disabled}
                Component={IconCircleLeft}
                onClick={() => onPrevRmaClick()}
            />
            <ButtonIcon
                disabled={!nextRmaId || disabled}
                Component={IconChevronRight}
                onClick={() => onNextRmaClick()}
            />
        </div>
    );
});

export default RmaNavigation;
